import React, { useCallback, useRef, useState, useEffect } from "react"
import JSONDep from "../../../json/Departamentos.json"
import JSONPro from "../../../json/Provincias.json"
import JSONDis from "../../../json/Distritos.json"
import PROYECTOS from "../../../json/ProyectosLibro.json"
import { Formik, Field, ErrorMessage } from 'formik';
import SectionBackground from "../../molecules/SectionBackground/SectionBackground"
import Title from "../../atoms/Title/Title"
import { css } from "@emotion/react"
import FormStyle from "./FormStyle"
import Step from "../Step/Step"
import { navigate } from "gatsby";

// Etiqueta visible del proyecto. Es tambien el value del option, lo que se envia
// al PDF y a CF7, y la llave de busqueda en handleProyecto: un solo lugar la arma
// para que los tres no puedan desalinearse.
const formatProyecto = (p) => `${p.nombre} - ${p.razonSocial} - RUC ${p.ruc}`;

export default function LibroForm({ title, legal }) {

  //ESTILOS

  const titleCss = css`
    font-size: calc(100vw * (calc(24 / var(--width_base))));
    font-weight: 400;
    margin-top: calc(100vw * (calc(20 / var(--width_base))));
    margin-bottom: calc(100vw * (calc(30 / var(--width_base))));
    padding-left: calc(100vw * (calc(13 / var(--width_base))));
    padding-right: calc(100vw * (calc(13 / var(--width_base))));
  `;

  const buttonCss = css`
    font-size: calc(100vw * (calc(16 / var(--width_base))));
    line-height: calc(100vw * (calc(16 / var(--width_base))));
    background-color: #eee !important;
    padding: calc(100vw * (calc(10 / var(--width_base)))) calc(100vw * (calc(15 / var(--width_base))));
    border: calc(100vw * (calc(1 / var(--width_base)))) solid #ddd;
    &:not(:last-of-type){
      margin-right: calc(100vw * (calc(20 / var(--width_base))));
    }
  `;

  const SectionCss = css`
      @media (max-width: 767px){
        padding-right: calc(100vw * (calc(7 / var(--width_base))));
        padding-left: calc(100vw * (calc(7 / var(--width_base))));
      }
    `;

  const reclamoBoxCss = css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: calc(100vw * (calc(15 / var(--width_base))));
    margin-bottom: calc(100vw * (calc(10 / var(--width_base))));
    padding: calc(100vw * (calc(15 / var(--width_base))));
    background-color: #f5f5f5;
    border-radius: calc(100vw * (calc(4 / var(--width_base))));
    font-size: calc(100vw * (calc(16 / var(--width_base))));

    @media (max-width: 767px){
    font-size: calc(100vw * (calc(12 / var(--width_base))));
      }
  `;

  const reclamoLabelCss = css`
    display: block;
    font-weight: 600;
    margin-bottom: calc(100vw * (calc(5 / var(--width_base))));
    font-size: calc(100vw * (calc(12 / var(--width_base))));
  `;

  const reclamoValueCss = css`
    padding: calc(100vw * (calc(10 / var(--width_base))));
    background-color: #fff;
    border-radius: calc(100vw * (calc(3 / var(--width_base))));
    font-weight: 500;
  `;

  const registrarButtonCss = css`
    font-size: calc(100vw * (calc(16 / var(--width_base))));
    line-height: calc(100vw * (calc(16 / var(--width_base))));
    background-color: #e39a00 !important;
    color: #fff !important;
    font-weight: 600;
    padding: calc(100vw * (calc(10 / var(--width_base)))) calc(100vw * (calc(15 / var(--width_base))));
    border: calc(100vw * (calc(1 / var(--width_base)))) solid #e39a00;
    &:not(:last-of-type){
      margin-right: calc(100vw * (calc(20 / var(--width_base))));
    }
  `;

  const archivosLabelCss = css`
    display: block;
    margin-bottom: calc(100vw * (calc(10 / var(--width_base))));
    font-size: calc(100vw * (calc(20 / var(--width_base))));
    font-weight: 600;
  `;

  const archivosMensajeCss = css`
    margin-top: calc(100vw * (calc(10 / var(--width_base))));
    font-size: calc(100vw * (calc(14 / var(--width_base))));
    color: #666;
  `;

  const archivoErrorCss = css`
    margin-top: calc(100vw * (calc(10 / var(--width_base))));
    font-size: calc(100vw * (calc(14 / var(--width_base))));
    color: #dc3545;
    font-weight: 500;
  `;

  const observacionesLabelCss = css`
    display: block;
    margin-bottom: calc(100vw * (calc(10 / var(--width_base))));
    font-size: calc(100vw * (calc(20 / var(--width_base))));
    font-weight: 600;
  `;

  const legalBoxCss = css`
    margin-top: calc(100vw * (calc(30 / var(--width_base))));   
    font-size: calc(100vw * (calc(14 / var(--width_base))));  
  `;

  const observacionesTextareaCss = css`
    border: none !important;
    background-color: transparent;
    resize: none;
    color: #000;
    &::placeholder {
      font-style: italic;
      color: #000;
    }
  `;

  const sectionMbCss = css`
    margin-bottom: calc(100vw * (calc(10 / var(--width_base))));  
  `;

  const ARCHIVOS_PERMITIDOS = ['application/pdf', 'image/png', 'image/jpeg', 'image/pjpeg'];
  const EXTENSIONES_PERMITIDAS = ['pdf', 'png', 'jpg', 'jpeg'];
  const MAX_ARCHIVO_SIZE = 4 * 1024 * 1024;

  const validarArchivo = (file) => {
    if (!file) {
      return { valido: false, mensaje: 'Archivo no válido' };
    }

    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!extension || !EXTENSIONES_PERMITIDAS.includes(extension)) {
      return { valido: false, mensaje: 'El archivo debe ser PDF, PNG o JPG' };
    }

    if (file.type && !ARCHIVOS_PERMITIDOS.includes(file.type)) {
      return { valido: false, mensaje: 'El archivo debe ser PDF, PNG o JPG' };
    }

    if (file.size > MAX_ARCHIVO_SIZE) {
      return { valido: false, mensaje: 'El archivo no debe superar 4MB' };
    }

    return { valido: true, mensaje: '' };
  };

  // LOGICA

  const [envio, setEnvio] = useState("")

  const [stepActive, setStepActive] = useState('datos')

  const [nomProyecto, setNomProyecto] = useState('')
  const [proyectoSel, setProyectoSel] = useState(null)
  const [idDepartamento, setIdDepartamento] = useState('')
  const [nomDepartamento, setNomDepartamento] = useState('')
  const [nomProvincia, setNomProvincia] = useState('')
  const [idProvincia, setIdProvincia] = useState('')
  const [nomDistrito, setNomDistrito] = useState('')
  const [idDistrito, setIdDistrito] = useState('')
  const [distritos, setDistritos] = useState('')
  const [provincias, setProvincias] = useState([])
  const [fechaReclamo, setFechaReclamo] = useState('')
  const [horaReclamo, setHoraReclamo] = useState('')
  const [codReclamoMuestra, setCodReclamoMuestra] = useState('')
  const [archivosAdjuntos, setArchivosAdjuntos] = useState(null)
  const [errorArchivo, setErrorArchivo] = useState('')
  const [descripcionProveedor, setDescripcionProveedor] = useState('Pendiente de respuesta del proveedor')
  const formikRef = useRef(null);
  const archivoInputRef = useRef(null);
  const archivosAdjuntosRef = useRef(null);


  const stepData = [
    {
      "id": 1,
      "text": "Datos del Reclamante"
    },
    {
      "id": 2,
      "text": "Identificación del Reclamo/Queja"
    },
    {
      "id": 3,
      "text": "Detalle del Reclamo/Queja y detalle"
    }
  ]


  const handleDep = useCallback((event) => {
    let valoresSelect = "";
    if (event.target.value !== "") {
      valoresSelect = event.target.value.split(",");
      setIdDepartamento(valoresSelect[0]);
      setNomDepartamento(valoresSelect[1]);
      const pro = JSONPro[0][valoresSelect[0]].map((ele, i) => {
        return (
          <option key={i} value={`${ele.id_ubigeo},${ele.nombre_ubigeo}`}>{ele.nombre_ubigeo}</option>
        )
      })
      setProvincias(pro);
    } else {
      setProvincias("")
      setNomDepartamento("")
      setNomProvincia("")
      setDistritos("")
      setNomDistrito("")
    }
    formikRef.current.setFieldValue("idProvincia", "");
    formikRef.current?.handleChange(event);
  }, []);


  const handleProv = useCallback((event) => {
    let valoresSelect = "";
    if (event.target.value !== "") {
      valoresSelect = event.target.value.split(",");
      setIdProvincia(valoresSelect[0])
      setNomProvincia(valoresSelect[1])
      const dis = JSONDis[0][valoresSelect[0]].map((ele, i) => {
        return (
          <option key={i} value={`${ele.id_ubigeo},${ele.nombre_ubigeo}`}>{ele.nombre_ubigeo}</option>
        )
      })
      setDistritos(dis)
    } else {
      setNomProvincia("")
      setNomDistrito("")
      setDistritos("")
    }
    formikRef.current.setFieldValue("idDistrito", "");
    formikRef.current?.handleChange(event);
  }, []);

  const handleDis = useCallback((event) => {
    let valoresSelect = "";
    if (event.target.value !== "") {
      valoresSelect = event.target.value.split(",");
      setIdDistrito(valoresSelect[0]);
      setNomDistrito(valoresSelect[1]);
    } else {
      setNomDistrito("")
    }
    formikRef.current?.handleChange(event);
  }, []);

  const handleProyecto = useCallback((event) => {
    const proyecto = PROYECTOS.find((p) => formatProyecto(p) === event.target.value);
    setProyectoSel(proyecto || null);
    setNomProyecto(proyecto ? proyecto.codigo : "");
    formikRef.current?.handleChange(event);
  }, []);

  // Función para formatear fecha con ceros
  const formatearFecha = (fecha) => {
    return fecha.split('/').map(parte => parte.padStart(2, '0')).join('/');
  };

  // Handler para capturar archivos adjuntos
  const handleArchivosAdjuntos = (event) => {
    const file = event.target.files[0];
    if (file) {
      const resultado = validarArchivo(file);

      if (!resultado.valido) {
        setErrorArchivo(resultado.mensaje);
        setArchivosAdjuntos(null);
        archivosAdjuntosRef.current = null;
        event.target.value = '';
        return;
      }

      setErrorArchivo('');
      setArchivosAdjuntos(file);
      archivosAdjuntosRef.current = file;
    } else {
      setArchivosAdjuntos(null);
      archivosAdjuntosRef.current = null;
      setErrorArchivo('');
    }
  };

  // Obtener fecha, hora y muestra del siguiente código de reclamo
  useEffect(() => {
    const now = new Date();
    const fecha = now.toLocaleDateString('es-PE');
    const fechaFormateada = formatearFecha(fecha);
    setFechaReclamo(fechaFormateada);

    // Actualizar hora cada segundo
    const updateHora = () => {
      const currentTime = new Date();
      const hora = currentTime.toLocaleTimeString('es-PE');
      setHoraReclamo(hora);
    };

    updateHora(); // Establecer la hora inicial
    const interval = setInterval(updateHora, 1000); // Actualizar cada segundo

    // Obtener el siguiente código de reclamo como muestra
    try {
      fetch(`${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/codReclamo/v1/codReclamo4`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json"
        },
      }).then(res => res.json())
        .then(json => {
          let numeroReclamo = parseInt(json) + 1;
          let year = now.getFullYear();
          let ceros = "";
          if (numeroReclamo >= 0 && numeroReclamo <= 9) ceros = "00";
          if (numeroReclamo >= 10 && numeroReclamo <= 99) ceros = "0";
          // Solo mostrar el número para la muestra, sin usar nomProyecto aún
          let codigoMuestra = ceros + numeroReclamo + "-" + year;
          setCodReclamoMuestra(codigoMuestra);
        })
        .catch(error => {
          console.error('Error al obtener código de reclamo:', error);
        });
    } catch (error) {
      console.error(error);
    }

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, []);

  return (
    <SectionBackground widthContent={1226} styleCss={SectionCss}>
      <Title typeEle="h1" text={title} styleCss={titleCss} />
      <Formik
        innerRef={formikRef}
        initialValues={{
          Nombre: '',
          Apellido: '',
          TipoDocumento: '',
          NroDocumento: '',
          Direccion: '',
          idDepartamento: '',
          idProvincia: '',
          idDistrito: '',
          Telefono: '',
          Email: '',
          Proyecto: '',
          QuejaReclamo: '',
          TipoServicio: '',
          TieneMontoReclamado: '',
          MontoReclamado: '',
          DescripcionReclamo: '',
          Pedido: '',
          DetalleReclamo: '',
          DescripcionProveedor: '',
          Acepto_condiciones: '',
          Acepto_condiciones2: '',
          Acepto_condiciones3: '',
        }}
        validate={values => {
          const errors = {};

          if (stepActive === "datos") {
            if (!values.Nombre) errors.Nombre = 'Campo requerido';
            if (!values.Apellido) errors.Apellido = 'Campo requerido';
            if (!values.TipoDocumento) errors.TipoDocumento = 'Campo requerido';
            if (!values.NroDocumento) errors.NroDocumento = 'Campo requerido';
            if (!values.Direccion) errors.Direccion = 'Campo requerido';
            if (!values.idDepartamento) errors.idDepartamento = 'Campo requerido';
            if (!values.idProvincia) errors.idProvincia = 'Campo requerido';
            if (!values.idDistrito) errors.idDistrito = 'Campo requerido';
            if (!values.Telefono) errors.Telefono = 'Campo requerido';
            if (!values.Email) errors.Email = 'Campo requerido';
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.Email)) errors.Email = 'Correo Invalido';
            if (!values.Proyecto) errors.Proyecto = 'Campo requerido';
          }

          if (stepActive === "identificacion") {
            if (!values.TipoServicio) errors.TipoServicio = 'Campo requerido';
            if (!values.TieneMontoReclamado) errors.TieneMontoReclamado = 'Campo requerido';
            if (values.TieneMontoReclamado === 'SI' && !values.MontoReclamado) errors.MontoReclamado = 'Campo requerido';
            if (!values.DescripcionReclamo) errors.DescripcionReclamo = 'Campo requerido';
          }

          if (stepActive === "detalle") {
            if (!values.QuejaReclamo) errors.QuejaReclamo = 'Campo requerido';
            if (!values.DetalleReclamo) errors.DetalleReclamo = 'Campo requerido';
            if (!values.Pedido) errors.Pedido = 'Campo requerido';
            if (!values.Acepto_condiciones) errors.Acepto_condiciones = 'Campo requerido';
            if (!values.Acepto_condiciones2) errors.Acepto_condiciones2 = 'Campo requerido';
            if (!values.Acepto_condiciones3) errors.Acepto_condiciones3 = 'Campo requerido';

            const fileInInput = archivoInputRef.current?.files?.[0];
            const archivo = fileInInput || archivosAdjuntosRef.current;
            if (archivo) {
              const resultado = validarArchivo(archivo);
              if (!resultado.valido) {
                errors.ArchivosAdjuntos = resultado.mensaje;
              }
            }
          }


          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          if (stepActive === "detalle") {
            const fileInInput = archivoInputRef.current?.files?.[0];
            const archivo = fileInInput || archivosAdjuntosRef.current;

            if (archivo) {
              const resultado = validarArchivo(archivo);
              if (!resultado.valido) {
                setErrorArchivo(resultado.mensaje);
                setArchivosAdjuntos(null);
                archivosAdjuntosRef.current = null;
                if (archivoInputRef.current) archivoInputRef.current.value = '';
                setSubmitting(false);
                return;
              }
            }

            try {
              fetch(`${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/codReclamo/v1/codReclamo4`, {
                method: 'GET',
                headers: {
                  "Content-Type": "application/json"
                },
              }).then(res => res.json())
                .then(json => {
                  let codReclamo = json;
                  let today = new Date();
                  let year = today.getFullYear();
                  let ceros = "";
                  if (codReclamo >= 0 && codReclamo <= 9) ceros = "00";
                  if (codReclamo >= 10 && codReclamo <= 99) ceros = "0";
                  let newcodigo = ceros + codReclamo + "-" + year + "-" + nomProyecto;
                  const montoReclamadoEnvio = values.TieneMontoReclamado === 'SI'
                    ? values.MontoReclamado
                    : 'No aplica';

                  // 1. PRIMERO: Generar PDF
                  const pdfData = {
                    CodReclamo: newcodigo,
                    FechaReclamo: fechaReclamo,
                    HoraReclamo: horaReclamo,
                    Nombre: values.Nombre,
                    Apellido: values.Apellido,
                    TipoDocumento: values.TipoDocumento,
                    NroDocumento: values.NroDocumento,
                    Direccion: values.Direccion,
                    Departamento: nomDepartamento,
                    Provincia: nomProvincia,
                    Distrito: nomDistrito,
                    Telefono: values.Telefono,
                    Email: values.Email,
                    Proyecto: values.Proyecto,
                    QuejaReclamo: values.QuejaReclamo,
                    TipoServicio: values.TipoServicio,
                    MontoReclamado: montoReclamadoEnvio,
                    DescripcionReclamo: values.DescripcionReclamo,
                    DetalleReclamo: values.DetalleReclamo,
                    Pedido: values.Pedido,
                    DescripcionProveedor: descripcionProveedor
                  };

                  fetch(`${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/pdf-libro/v1/generar-pdf`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(pdfData)
                  })
                    .then(res => res.json())
                    .then(pdfJson => {
                      console.log('Respuesta PDF:', pdfJson);
                      if (pdfJson.url_pdf) {
                        sessionStorage.setItem('urlPDF', pdfJson.url_pdf);
                      }

                      // 2. DESPUÉS: Enviar a CF7
                      const formData = new FormData();
                      formData.append("_wpcf7_unit_tag", "wpcf7-f6-o1")
                      formData.append("CodReclamo", newcodigo);
                      formData.append("FechaReclamo", fechaReclamo);
                      formData.append("HoraReclamo", horaReclamo);
                      formData.append("Nombre", values.Nombre);
                      formData.append("Apellido", values.Apellido);
                      formData.append("TipoDocumento", values.TipoDocumento);
                      formData.append("NroDocumento", values.NroDocumento);
                      formData.append("Direccion", values.Direccion);
                      formData.append("Departamento", nomDepartamento);
                      formData.append("Provincia", nomProvincia);
                      formData.append("Distrito", nomDistrito);
                      formData.append("Telefono", values.Telefono);
                      formData.append("Email", values.Email);
                      formData.append("Proyecto", values.Proyecto);
                      formData.append("QuejaReclamo", values.QuejaReclamo);
                      formData.append("TipoServicio", values.TipoServicio);
                      formData.append("MontoReclamado", montoReclamadoEnvio);
                      formData.append("DescripcionReclamo", values.DescripcionReclamo);
                      formData.append("DetalleReclamo", values.DetalleReclamo);
                      formData.append("NombreProyecto", nomProyecto);
                      formData.append("CorreoProyecto", proyectoSel?.correo || "");
                      formData.append("Pedido", values.Pedido);
                      formData.append("DescripcionProveedor", descripcionProveedor);

                      if (archivosAdjuntosRef.current) {
                        const archivoValidado = archivosAdjuntosRef.current;
                        const resultado = validarArchivo(archivoValidado);
                        if (!resultado.valido) {
                          setErrorArchivo(resultado.mensaje);
                          setArchivosAdjuntos(null);
                          archivosAdjuntosRef.current = null;
                          setSubmitting(false);
                          return;
                        }
                        formData.append("ArchivosAdjuntos", archivoValidado);
                      }

                      fetch(`${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/contact-form-7/v1/contact-forms/6/feedback`, {
                        method: 'POST',
                        body: formData
                      })
                        .then(res => res.json())
                        .then(json => {
                          console.log('Respuesta CF7:', json);
                          if (json.status === "mail_sent") {
                            setEnvio(true);
                            setSubmitting(false);
                            setArchivosAdjuntos(null);
                            archivosAdjuntosRef.current = null;
                            setErrorArchivo('');
                            resetForm();
                            navigate('/gracias-libro-reclamaciones');
                          } else {
                            setEnvio(false);
                            setSubmitting(false);
                            setStepActive('datos');
                          }
                        })
                        .catch(error => {
                          console.error('Error CF7:', error);
                          setEnvio(false);
                          setSubmitting(false);
                          setStepActive('datos');
                        });
                    })
                    .catch(error => {
                      console.error('Error generando PDF:', error);
                      setSubmitting(false);
                      setStepActive('datos');
                    });
                })
            } catch (error) {
              console.error(error);
              setEnvio(false);
              setStepActive('datos');
            }
          }
          if (stepActive === "datos") { setStepActive('identificacion'); setSubmitting(false); }
          if (stepActive === "identificacion") { setStepActive('detalle'); setSubmitting(false); }
        }}
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <FormStyle>

            <input type="hidden" value={idDepartamento} name="IdDepartamento" />
            <input type="hidden" value={nomDepartamento} name="nomDepartamento" />
            <input type="hidden" value={nomProvincia} name="nomProvincia" />
            <input type="hidden" value={idProvincia} name="idProvincia" />
            <input type="hidden" value={nomDistrito} name="nomDistrito" />
            <input type="hidden" value={idDistrito} name="idDistrito" />

            <Step navElements={stepData} navNumActives={1} active={stepActive === "datos"}>
              <div className="form-group grid-100">
                <div css={reclamoBoxCss}>
                  <div>
                    <label css={reclamoLabelCss}>Nro Reclamo</label>
                    <div css={reclamoValueCss}>
                      {codReclamoMuestra || '(Cargando...)'}
                    </div>
                  </div>
                  <div>
                    <label css={reclamoLabelCss}>Fecha</label>
                    <div css={reclamoValueCss}>
                      {fechaReclamo}
                    </div>
                  </div>
                  <div>
                    <label css={reclamoLabelCss}>Hora</label>
                    <div css={reclamoValueCss}>
                      {horaReclamo}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group grid-100">
                <Field className="form-control" type="text" name="Nombre" placeholder="*Nombres" />
                <ErrorMessage className="form-error" name="Nombre" component="div" />
              </div>
              <div className="form-group grid-100">
                <Field className="form-control" type="text" name="Apellido" placeholder="*Apellidos" />
                <ErrorMessage className="form-error" name="Apellido" component="div" />
              </div>
              <div className="form-group grid-50 mobile-grid-50 space-right">
                <Field name="TipoDocumento" as="select" className="form-control">
                  <option value="">*Tipo de documento</option>
                  <option value="DNI">DNI</option>
                  <option value="PASAPORTE">PASAPORTE</option>
                  <option value="RUC">RUC</option>
                  <option value="CARNET EXTRANJERIA">Carnet Extranjería</option>
                </Field>
                <ErrorMessage className="form-error" name="TipoDocumento" component="div" />
              </div>
              <div className="form-group grid-50 mobile-grid-50 space-left">
                <Field className="form-control" type="text" name="NroDocumento" placeholder="*Nro de documento" />
                <ErrorMessage className="form-error" name="NroDocumento" component="div" />
              </div>
              <div className="form-group grid-100">
                <Field name="Direccion" as="textarea" className="form-control" placeholder="*Dirección">
                </Field>
                <ErrorMessage className="form-error" name="Direccion" component="div" />
              </div>
              <div className="form-group grid-33 mobile-grid-33 space-right">
                <Field name="idDepartamento" as="select" className="form-control" onChange={handleDep}>
                  <option value="">Seleccionar</option>
                  {
                    JSONDep && JSONDep.map((dep, i) => (
                      <option key={i} value={`${dep.id_ubigeo},${dep.nombre_ubigeo}`}>{dep.nombre_ubigeo}</option>
                    ))
                  }
                </Field>
                <ErrorMessage className="form-error" name="idDepartamento" component="div" />
              </div>
              <div className="form-group grid-33 mobile-grid-33 space-right space-left">
                <Field name="idProvincia" as="select" className="form-control" onChange={handleProv}>
                  <option value="">Seleccionar</option>
                  {provincias}
                </Field>
                <ErrorMessage className="form-error" name="idProvincia" component="div" />
              </div>
              <div className="form-group grid-33 mobile-grid-33 space-left">
                <Field name="idDistrito" as="select" className="form-control" onChange={handleDis}>
                  <option value="">Seleccionar</option>
                  {distritos}
                </Field>
                <ErrorMessage className="form-error" name="idDistrito" component="div" />
              </div>
              <div className="form-group grid-50  mobile-grid-50 space-right">
                <Field className="form-control" type="text" name="Telefono" placeholder="*Teléfono fijo / Movil" />
                <ErrorMessage className="form-error" name="Telefono" component="div" />
              </div>
              <div className="form-group grid-50 mobile-grid-50 space-left">
                <Field className="form-control" type="text" name="Email" placeholder="*Correo Electrónico" />
                <ErrorMessage className="form-error" name="Email" component="div" />
              </div>
              <div className="form-group grid-100">
                <Field name="Proyecto" as="select" className="form-control" onChange={handleProyecto}>
                  <option value="">*Seleccionar proyecto</option>
                  {
                    PROYECTOS.map((p) => (
                      <option key={p.key} value={formatProyecto(p)}>{formatProyecto(p)}</option>
                    ))
                  }
                </Field>
                <ErrorMessage className="form-error" name="Proyecto" component="div" />
              </div>
              <div className="form-group grid-100">
                <button type="submit" css={buttonCss}>Siguiente</button>
              </div>
            </Step>
            <Step navElements={stepData} navNumActives={2} active={stepActive === "identificacion"}>
              <div className="form-group grid-50 mobile-grid-50 space-right">
                <Field name="TipoServicio" as="select" className="form-control">
                  <option value="">--Tipo de servicio--</option>
                  <option value="Producto">Producto</option>
                  <option value="Servicio">Servicio</option>
                </Field>
                <ErrorMessage className="form-error" name="TipoServicio" component="div" />
              </div>
              <div className="form-group grid-50 mobile-grid-50 space-left">
                <Field
                  name="TieneMontoReclamado"
                  as="select"
                  className="form-control"
                  onChange={(e) => {
                    if (e.target.value !== 'SI') {
                      setFieldValue('MontoReclamado', '');
                    }
                    setFieldValue('TieneMontoReclamado', e.target.value);
                  }}
                >
                  <option value="">*¿Tiene monto reclamado?</option>
                  <option value="SI">Sí</option>
                  <option value="NO">No</option>
                </Field>
                <ErrorMessage className="form-error" name="TieneMontoReclamado" component="div" />
              </div>
              {values.TieneMontoReclamado === 'SI' && (
                <div className="form-group grid-50 mobile-grid-50 space-right">
                  <Field className="form-control" type="text" name="MontoReclamado" placeholder="*Monto reclamado" />
                  <ErrorMessage className="form-error" name="MontoReclamado" component="div" />
                </div>
              )}
              <div className="form-group grid-100">
                <Field className="form-control" as="textarea" name="DescripcionReclamo" placeholder="*Descripción del reclamo" maxLength={1000} />
                <ErrorMessage className="form-error" name="DescripcionReclamo" component="div" />
              </div>
              {/*<div className="form-group form-label grid-100">* El proveedor deberá dar respuesta al reclamo en un plazo no mayor a quince (15) días calendario, pudiendo ampliar el plazo hasta por treinta (30) días más, previa comunicación al consumidor.</div>*/}
              <div className="form-group form-label grid-100">*El proveedor debe dar respuesta al reclamo o queja en un plazo no mayor a quince (15) días hábiles, el cual es improrrogable.</div>
              <div className="form-group grid-100">
                <button type="button" css={buttonCss} onClick={() => setStepActive('datos')}>Anterior</button>
                <button type="submit" css={buttonCss}>Siguiente</button>
              </div>
            </Step>
            <Step navElements={stepData} navNumActives={3} active={stepActive === "detalle"}>
              <div className="form-group grid-100">
                <label htmlFor="Queja" className="form-label">
                  <Field className="form-control" type="radio" name="QuejaReclamo" id="Queja" value="Queja: Disconformidad no relacionada a los productos o servicios; o, malestar o descontento respecto a la atención al público." />
                  &nbsp;&nbsp;Queja: Disconformidad no relacionada a los productos o servicios; o, malestar o descontento respecto a la atención al público.
                </label>
                <label htmlFor="Reclamo" className="form-label">
                  <Field className="form-control" type="radio" name="QuejaReclamo" id="Reclamo" value="Reclamo: Disconformidad relacionada a los productos y servicios." />
                  &nbsp;&nbsp;Reclamo: Disconformidad relacionada a los productos y servicios.
                </label>
                <ErrorMessage className="form-error" name="QuejaReclamo" component="div" />
              </div>
              <div className="form-group grid-100">
                <Field className="form-control" as="textarea" name="DetalleReclamo" placeholder="Detalle del reclamo o queja" maxLength={1000} />
                <ErrorMessage className="form-error" name="DetalleReclamo" component="div" />
              </div>
              <div className="form-group grid-100">
                <Field className="form-control" as="textarea" name="Pedido" placeholder="Pedido del reclamo o queja" maxLength={1000} />
                <ErrorMessage className="form-error" name="Pedido" component="div" />
              </div>
              <div className="form-group grid-100">
                <label htmlFor="ArchivosAdjuntos" css={archivosLabelCss}>Archivos Adjuntos (PDF, PNG, JPG - Máximo 4MB)</label>
                <input
                  type="file"
                  id="ArchivosAdjuntos"
                  ref={archivoInputRef}
                  className="form-control"
                  onChange={handleArchivosAdjuntos}
                  accept=".pdf,.png,.jpg,.jpeg"
                />
                {errorArchivo && (
                  <div css={archivoErrorCss}>
                    <p>{errorArchivo}</p>
                  </div>
                )}
                <ErrorMessage className="form-error" name="ArchivosAdjuntos" component="div" />
                {archivosAdjuntos && !errorArchivo && (
                  <div css={archivosMensajeCss}>
                    <p>✓ Archivo seleccionado: {archivosAdjuntos.name} ({(archivosAdjuntos.size / 1024).toFixed(2)} KB)</p>
                  </div>
                )}
              </div>
              <div className="form-group grid-100" >
                <label htmlFor="DescripcionProveedor" css={observacionesLabelCss}>Observaciones y acciones adoptadas por el proveedor</label>
                <textarea
                  id="DescripcionProveedor"
                  className="form-control"
                  css={observacionesTextareaCss}
                  name="DescripcionProveedor"
                  value="Al ser un reclamo o queja virtual, su caso será derivado al área encargada a fin de dar respuesta dentro del plazo legalmente establecido"
                  placeholder="Al ser un reclamo o queja virtual, su caso será derivado al área encargada a fin de dar respuesta dentro del plazo legalmente establecido"
                  maxLength={1000}
                  readOnly
                />
              </div>
              <div className="grid-100" css={sectionMbCss}>
                <label className="form-acept form-label" htmlFor="Acepto_condiciones">
                  <Field className="" type="checkbox" name="Acepto_condiciones" id="Acepto_condiciones" />&nbsp;&nbsp;Al enviar este reclamo / queja usted está conforme con los datos consignados.</label>
                <ErrorMessage className="form-error mov-mb-13" name="Acepto_condiciones" component="div" />
              </div>
              <div className="grid-100" css={sectionMbCss}>
                <label className="form-acept form-label" htmlFor="Acepto_condiciones2">
                  <Field className="" type="checkbox" name="Acepto_condiciones2" id="Acepto_condiciones2" />&nbsp;&nbsp;He leído y acepto la  {" "}
                  <a
                    href="/politica-de-privacidad/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Política de privacidad
                  </a>
                </label>
                <ErrorMessage className="form-error mov-mb-13" name="Acepto_condiciones2" component="div" />
              </div>
              <div className="grid-100" css={sectionMbCss}>
                <label className="form-acept form-label" htmlFor="Acepto_condiciones3">
                  <Field className="" type="checkbox" name="Acepto_condiciones3" id="Acepto_condiciones3" />&nbsp;&nbsp;He leído y acepto la transferencia de mis datos a las empresas del grupo empresarial Armando Paredes.</label>
                <ErrorMessage className="form-error mov-mb-13" name="Acepto_condiciones3" component="div" />
              </div>
              <div className="form-group grid-100">
                <button type="button" css={buttonCss} onClick={() => setStepActive('identificacion')}>Anterior</button>
                <button type="submit" disabled={isSubmitting} css={registrarButtonCss}>
                  {isSubmitting ? '⏳ Registrando...' : 'Registrar'}
                </button>
              </div>
              {legal && (
                <div className="form-group grid-100" css={legalBoxCss}>
                  <div dangerouslySetInnerHTML={{ __html: legal }} />
                </div>
              )}
            </Step>
            <div className="grid-100">
              {(envio === false && envio !== "") && <div className="">Error en el envio</div>}
              {(envio === true && envio !== "") && <div className="">Correo enviado</div>}
            </div>
          </FormStyle>
        )}
      </Formik>
    </SectionBackground>
  );

}